import { useIdentity } from '~/store/identity'
import isAmountBetween from '~/utils/isAmountBetween'
import PaymentProcessorsEnum from '~/enums/PaymentProcessorsEnum'
import type { BackendPaymentProcessorResponse } from '~/types/payment/paymentBackendTypes'
import calculatePaymentFees from '~/utils/balance/calculatePaymentFees'

export default async (countries: any[], amount: number, country_id: number) => {
  const selectedCountry = countries.find((country) => country.country_id === country_id)

  const allProcessors: BackendPaymentProcessorResponse[] = selectedCountry.payment_processors

  return calculatePaymentFees(await preformatProcessors(allProcessors, selectedCountry, amount), amount)
}

async function preformatProcessors(
  processors: BackendPaymentProcessorResponse[],
  country: any,
  amount: number
): Promise<BackendPaymentProcessorResponse[]> {
  const identity = useIdentity()
  const user = await identity.getUser()
  const formattedProcessors: BackendPaymentProcessorResponse[] = []
  processors.forEach((processor: Partial<BackendPaymentProcessorResponse>) => {
    if (
      processor.active === 1 &&
      processor.enable_for_balance === 1 &&
      processor.payment_processor &&
      isAmountBetween(amount, processor.balance_min_amount ?? null, processor.balance_max_amount ?? null)
    ) {
      if (processor.payment_processor.id === PaymentProcessorsEnum.ShipzeeBalance) {
        if (country.enabled_balance) {
          processor.partial_balance = true
        } else if ((user?.balance ?? 0) >= amount) {
          processor.partial_balance = false
        } else {
          return
        }
      }

      processor.min_amount = processor.balance_min_amount ?? 0
      processor.max_amount = processor.balance_max_amount ?? 0
      processor.fee_type = processor.balance_fee_type ?? 0
      processor.fee = processor.balance_fee ?? 0
      formattedProcessors.push(processor as BackendPaymentProcessorResponse)
    }
  })

  return formattedProcessors
}
